import httpService from "@Utils/httpService";

const baseUrl = "api/AccessLists";

export default {
  get() {
    return httpService.get({
      url: `${baseUrl}`,
    });
  },
  switch(companyId) {
    return httpService.post({
      url: `${baseUrl}/switch/${companyId}`,
    });
  },
  favourite(data) {
    return httpService.put({
      url: `${baseUrl}/favourite`,
      data,
    });
  },
};
